import { sqSeriesRuntimeStore } from '@/core/core.stores';
import { freezeOutsideProduction } from '@/core/immutability.utilities';
import type { ITEM_TYPES } from '@/trendData/trendData.constants';

/**
 * Overlays the fetched render data onto a series so readers see it alongside its config. Series
 * with no entry are returned as-is (identity preserved).
 *
 * This module must stay free of imports that reach back into the overlay registry (the module
 * cycle through `trend.actions` leaves the registry holding `undefined`); the write-side helpers
 * live in `seriesRuntime.actions.ts` for that reason.
 */
export function withSeriesValues<T extends { id: string; itemType: ITEM_TYPES.SERIES }>(item: T): T {
  const values = sqSeriesRuntimeStore.getState().values[item.id];
  return values ? freezeOutsideProduction({ ...item, ...values }) : item;
}
